
import { computed, defineComponent, Ref } from 'vue';
import authStore from '@/shared/auth/auth.store';
import utilities from '@/shared/utilities.service';

export default defineComponent({
    name: 'CustomerServiceBar',
    setup() {
        const signOut = authStore.customerServiceSignOut;
        const isCustomerService = authStore.isCustomerService;

        const infoTextHTML: Ref<string> = computed(() => {
            const HTMLString = '<strong>{0}</strong>, you are signed in on behalf of <strong>{1}</strong> ({2})';
            return utilities.formatString(HTMLString, [
                authStore.userData.customerServiceImpersonateUserName,
                authStore.userData.name,
                authStore.userData.unique_name,
            ]);
        });

        return {
            isCustomerService,
            signOut,
            infoTextHTML,
        };
    },
});
